import { render } from "./_itemID.vue?vue&type=template&id=53bc225b"
import script from "./_itemID.vue?vue&type=script&lang=js"
export * from "./_itemID.vue?vue&type=script&lang=js"

import "./_itemID.vue?vue&type=style&index=0&id=53bc225b&lang=css"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__